import { rtkApi } from '@/shared/api';
import { SuccessApiResponse } from '@/shared/types/common';
import {
  ITurnitinEulaInfoRequest,
  ITurnitinEulaInfoResponse,
  ITurnitinEulaAcceptRequest,
  ITurnitinEulaAcceptResponse,
  ITurnitinEulaStatusResponse,
  ITurnitinEulaPageRequest,
  ITurnitinViewerRequest,
  ITurnitinViewerResponse,
} from './types';

const turnitinApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getTurnitinEulaInfo: build.query<ITurnitinEulaInfoResponse, ITurnitinEulaInfoRequest | void>({
      query: (params) => ({
        url: '/turnitin-eula/info',
        ...(params ? { params } : {}),
      }),
      transformResponse: (response: SuccessApiResponse<ITurnitinEulaInfoResponse>) => response.data,
    }),
    getTurnitinEulaPage: build.query<string, ITurnitinEulaPageRequest | void>({
      query: (params) => ({
        url: '/turnitin-eula/page',
        params: params ? { lang: params.lang } : undefined,
        headers: {
          Accept: 'text/html',
        },
        responseHandler: 'text',
      }),
    }),
    acceptTurnitinEula: build.mutation<ITurnitinEulaAcceptResponse, ITurnitinEulaAcceptRequest>({
      query: (body) => ({
        url: '/turnitin-eula/accept',
        method: 'POST',
        body,
      }),
      transformResponse: (response: SuccessApiResponse<ITurnitinEulaAcceptResponse>) =>
        response.data,
    }),
    getTurnitinEulaStatus: build.query<ITurnitinEulaStatusResponse, void>({
      query: () => ({
        url: '/turnitin-eula/status',
      }),
      transformResponse: (response: SuccessApiResponse<ITurnitinEulaStatusResponse>) =>
        response.data,
    }),
    getTurnitinViewerUrl: build.query<ITurnitinViewerResponse, ITurnitinViewerRequest>({
      query: (submissionId) => ({
        url: `/turnitin/viewer/${submissionId}`,
      }),
      transformResponse: (response: SuccessApiResponse<ITurnitinViewerResponse>) => response.data,
    }),
  }),
});

export const {
  useLazyGetTurnitinEulaInfoQuery,
  useLazyGetTurnitinEulaPageQuery,
  useLazyGetTurnitinEulaStatusQuery,
  useAcceptTurnitinEulaMutation,
  useLazyGetTurnitinViewerUrlQuery,
} = turnitinApi;
